<template>
  <div class="box">
    <p class="logo">
      <span>后台管理</span>
    </p>
    <el-row class="tac">
      <el-col :span="24">
        <el-menu
          :default-active="active"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          background-color="#314256"
          text-color="rgb(191, 203, 217)"
          :unique-opened="true"
          :router="true"
          active-text-color="#48A1FE"
        >
          <el-menu-item index="user">
            <i class="el-icon-">
              <svg-icon icon-class="user" />
            </i>
            <span slot="title">用户管理</span>
          </el-menu-item>
          <el-menu-item index="doctor">
            <i class="el-icon-">
              <svg-icon icon-class="doctor" />
            </i>
            <span slot="title">医生管理</span>
          </el-menu-item>
          <el-menu-item index="street">
            <i class="el-icon-">
              <svg-icon icon-class="street" />
            </i>
            <span slot="title">街道管理</span>
          </el-menu-item>
          <el-menu-item index="hospital">
            <i class="el-icon-">
              <svg-icon icon-class="hospital" />
            </i>
            <span slot="title">医院管理</span>
          </el-menu-item>
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-">
                <svg-icon icon-class="page-t" />
              </i>
              <span>文章管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="Popularscience">科普文章</el-menu-item>
              <el-menu-item index="policy">政策法规</el-menu-item>
              <el-menu-item index="activity">活动管理</el-menu-item>
              <el-menu-item index="latestInformation">最新信息</el-menu-item>
              <el-menu-item index="moneyStand">收费标准</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item index="banner">
            <i class="el-icon-">
              <svg-icon icon-class="warehouse" />
            </i>
            <span slot="title">广告管理</span>
          </el-menu-item>
          <el-menu-item index="team">
            <i class="el-icon-">
              <svg-icon icon-class="user" />
            </i>
            <span slot="title">专家团队</span>
          </el-menu-item>
          <el-menu-item index="edition">
            <i class="el-icon-">
              <svg-icon icon-class="Edition-t" />
            </i>
            <span slot="title">版本号管理</span>
          </el-menu-item>
          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-">
                <svg-icon icon-class="System-t" />
              </i>
              <span>系统设置</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="setup">客服管理</el-menu-item>
              <el-menu-item index="money">支付管理</el-menu-item>
              <el-menu-item index="health">健康教育</el-menu-item>
              <el-menu-item index="moneyArtical">服务说明</el-menu-item>
              <el-menu-item index="homeWords">首页展示文字</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
           <el-submenu index="3">
            <template slot="title">
              <i class="el-icon-">
                <svg-icon icon-class="System-t" />
              </i>
              <span>朵尔美&美奇</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="couponManagement">优惠券管理</el-menu-item>
              <el-menu-item index="orderManagement">订单管理</el-menu-item>
              <el-menu-item index="financialManagement">财务管理</el-menu-item>
              <el-menu-item index="activityDetailsMaintenance">活动细则维护</el-menu-item>
   
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">
              <i class="el-icon-">
                <svg-icon icon-class="System-t" />
              </i>
              <span>线下活动管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="offlineActivityList">线下活动列表</el-menu-item>
              <el-menu-item index="bookingManagement">预约管理</el-menu-item>
              <el-menu-item index="listOfRegisteredUsers">报名用户列表</el-menu-item>
              <el-menu-item index="onSiteVerification">现场核销</el-menu-item>
              <el-menu-item index="timeSetting">时间设置</el-menu-item>
   
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>


<script>
import Cookies from "js-cookie";

export default {
  data() {
    return {
      label: [],
    };
  },
  computed: {
    active() {
      let path = this.$route.path.split("/");
      path = path[path.length - 1];
      // console.log(path, "======6666666666666666666666");
      return path;
    },
  },
  watch: {
    $route(to, from) {
      // console.log(to.path, "=============");
      this.islogin();
    },
  },
  mounted() {
    this.islogin();
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    islogin() {
      // 判断是否登录
      if (!Cookies.get("healthadminId")) {
        this.$message({
          message: "登录已过期，请重新登录",
          type: "warning",
        });
        let path = this.$route.path;
        this.$router.push({ path: "login?path=" + path });
        this.$store.dispatch("layout");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  width: 200px;
  height: 59px;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
  background: #314256;
  display: flex;
  align-items: center;
  color: rgb(191, 203, 217);
  font-size: 18px;
  position: fixed;
  top: 0;
  left: 0;
  & > span {
    margin-left: 25px;
  }
}
.tac {
  width: 200px;
  height: 100%;
  background: #314256;
  position: fixed;
  top: 60px;
  left: 0;
  overflow-y: scroll;
  .el-menu-item-group,
  .el-submenu,
  .el-menu-item {
    width: 200px;
  }
}
/*滚动条样式*/
.tac::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 0px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 0px;
}
.tac::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 2px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.tac::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.el-submenu [class^="el-icon-"] {
  color: rgb(191, 203, 217) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/slider.vue